module.exports = __webpack_public_path__ + "img/888.c7143e27.gif";